import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { IInsertMediaResult } from '@fi-shared/fi-insert-media/fi-insert-media';
import { FiInsertMedia2Service } from '@fi-shared/fi-insert-media/fi-insert-media2.service';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { ObjectTypes } from '@fi-shared/types';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'fi-message-attachments-menu',
    templateUrl: './message-attachments-menu.component.html',
    styleUrls: ['./message-attachments-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-message-attachments-menu' },
    standalone: false,
})
export class FiMessageAttachmentsMenuComponent {
    @Input() isGIFDisabled: boolean = false;
    @Output() addMessageAttachments = new EventEmitter<IMediaBankFileReference[]>();
    @Output() showGiphyOverlay = new EventEmitter<void>();

    protected isAttachmentsMenuOpened$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(private fiInsertMedia2Service: FiInsertMedia2Service) {}

    protected animateAttachmentsButton(): void {
        this.isAttachmentsMenuOpened$.next(!this.isAttachmentsMenuOpened$.value);
    }

    protected openInsertMediaDialog(filesToUpload?: File[]): void {
        this.fiInsertMedia2Service
            .openInsertMediaDialogWithFileSizes(ObjectTypes.ChatConversationMessage, {
                filesToUpload: filesToUpload,
                restoreFocus: true,
            })
            .onYesButtonClick((result: IInsertMediaResult) => {
                this.addMessageAttachments.emit(result.mediaBankFileReferences);
            });
    }
}
